import { Typography } from "@material-ui/core";
import clsx from "clsx";
import { ReactNode } from "react";

import styles from "./description-divider.module.scss";

function DescriptionDivider({
  text,
}: {
  text?: ReactNode | null;
}): JSX.Element {
  return (
    <div
      className={clsx(
        styles.descriptionWrapper,
        "text-center w-full flex leading-6 h-6 my-2"
      )}
    >
      {text && <Typography className="mx-2">{text}</Typography>}
    </div>
  );
}

export default DescriptionDivider;
